export default {
  name: 'BaseDialog',
  props: {
    refName: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curLocationPointInfo: {},
      locationPointList: []
    }
  },
  watch: {
    visible: function(newValue) {
      if (newValue === true) {
        this.init()
      }
    }
  },
  mounted() {

  },
  methods: {
    init() {

    },
    closeDialog() {
      this.$emit('update:visible', false)
    }
  }
}
